var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsset10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.88 4.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.26,.02c-3.88-.01-7.74-.01-11.62-.01h-5.71C12.73,.02,10.59,0,8.45,0,6.86,0,5.27-.01,3.68,0h-.14C3.19,0,2.84,0,2.49,.02,.62,.06-.55,1.94,.26,3.58c.5,1.01,1.38,1.4,2.48,1.4h1.04c3.48,0,6.98,0,10.46-.01H30.78s.04,.01,.04,.01c.58,0,1.17,.02,1.75-.02,1.27-.09,2.21-1.06,2.3-2.3,.1-1.49-1.01-2.64-2.61-2.64Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset10);
export default __webpack_public_path__ + "static/media/Asset 10.36b6548337644a17783e057e74109b89.svg";
export { ForwardRef as ReactComponent };